import React, {
    useContext,
    useState,
  } from "react";
  
  import { ShopContext } from "../../Context/ShopContext";
  import { useCartStore } from "../../stores/useCartStores";
  import "./Wishlist.css";
  
  const SERVER_URL = (
    process.env.REACT_APP_API_BASE_URL ||
    "http://localhost:5000/api"
  ).replace(/\/api\/?$/, "");
  
  const resolveImage = (image) => {
    if (!image) {
      return "https://via.placeholder.com/150";
    }
  
    return image.startsWith("http")
      ? image
      : `${SERVER_URL}${image}`;
  };
  
  const Wishlist = () => {
    const {
      wishlist = [],
      removeFromWishlist,
    } = useContext(ShopContext);
  
    const { addToCart } = useCartStore();
  
    const [floatingMessage, setFloatingMessage] =
      useState("");
  
    const showFloatingMessage = (message) => {
      setFloatingMessage(message);
  
      setTimeout(() => {
        setFloatingMessage("");
      }, 3000);
    };
  
    const handleMoveToCart = async (item) => {
      if (!item.size) {
        showFloatingMessage(
          "Please select a size before moving to cart."
        );
  
        return;
      }
  
      try {
        await addToCart(
          item.id,
          Number(item.quantity || 1),
          item.size
        );
  
        removeFromWishlist(item.id);
  
        showFloatingMessage(
          "Item moved to cart successfully! 🛒"
        );
      } catch (error) {
        console.error(
          "Failed to add to cart:",
          error
        );
  
        showFloatingMessage(
          error.response?.data?.message ||
            "Failed to move item to cart. Please try again."
        );
      }
    };
  
    return (
      <div className="wishlist">
        <h1>My Wishlist</h1>
  
        {wishlist.length === 0 ? (
          <p>Your wishlist is empty.</p>
        ) : (
          <div className="wishlist-container">
            <div className="wishlist-header">
              <p />
              <p>PRODUCT</p>
              <p>TITLE</p>
              <p>SIZE</p>
              <p>PRICE</p>
              <p>QUANTITY</p>
              <p>ACTION</p>
            </div>
  
            <hr />
  
            {wishlist.map((item) => (
              <div
                key={`${item.id}-${item.size}`}
                className="wishlist-item"
              >
                <button
                  type="button"
                  className="wishlist-remove-btn"
                  onClick={() =>
                    removeFromWishlist(item.id)
                  }
                  aria-label={`Remove ${item.name} from wishlist`}
                >
                  ✕
                </button>
  
                <img
                  className="wishlist-product-img"
                  src={resolveImage(item.image)}
                  alt={item.name}
                />
  
                <p>{item.name}</p>
                <p>{item.size}</p>
                <p>₦{item.price}</p>
                <p>{item.quantity || 1}</p>
  
                <button
                  type="button"
                  className="wishlist-move-to-cart"
                  onClick={() =>
                    handleMoveToCart(item)
                  }
                >
                  Add to Cart
                </button>
              </div>
            ))}
          </div>
        )}
  
        {floatingMessage && (
          <div className="floating-message">
            {floatingMessage}
          </div>
        )}
      </div>
    );
  };
  
  export default Wishlist;